import React from 'react';

import { Alert, AlertDescription, AlertIcon } from '@chakra-ui/react';

/** An informational message in place of API reference content. */
export const ApiNotice = ({ children }: { children: React.ReactNode }) => (
  <Alert status="info" borderRadius="md">
    <AlertIcon />
    <AlertDescription>{children}</AlertDescription>
  </Alert>
);
